import { ReactElement } from "react"

import CreateEbDeviceForm from "../../../../components/devices/lct/eb/createEbDeviceForm"
import ContinueEbDeviceVersionProvider from "../../../../components/devices/lct/eb/providers/continueEbDeviceVersionProvider"

const ContinueEbDraftDeviceVersion = (): ReactElement => (
    <ContinueEbDeviceVersionProvider>
        <CreateEbDeviceForm />
    </ContinueEbDeviceVersionProvider>
)

export default ContinueEbDraftDeviceVersion
